<template>
  <v-container fluid>
    <v-row justify="end">
      <v-col cols="1" class="text-right">
        <v-btn color="primary" @click="addNew()">Dodaj</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
            :items="items"
            :headers="headers"
            hide-default-footer
            disable-pagination>
          <template v-slot:item="props">
            <tr>
              <td>{{props.item.kod_resortowy}}</td>
              <td>{{props.item.nazwa}}</td>
              <td><v-checkbox disabled v-model="props.item.is_active"></v-checkbox></td>
              <td>
                <v-icon small class="mr-2"  @click="editOU(props.item)" title="Edytuj komórke">fa-edit</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <AddEditJednostkaOrganizacyjna v-if="showAddEdit" :edited_object="editedObject" :visible="showAddEdit" @close="showAddEdit = false" @edited="editedDone"></AddEditJednostkaOrganizacyjna>
  </v-container>
</template>

<script>
import {settingsService} from "@/services";
import swal from "sweetalert";
import AddEditJednostkaOrganizacyjna from "@/components/admin/settings/AddEditJednostkaOrganizacyjna";

export default {
  name: "JednostkiOrganizacyjne",
  components: {AddEditJednostkaOrganizacyjna},
  props: ["settings_id"],
  data() {
    return {
      items: [],
      showAddEdit: false,
      editedObject: null,
      headers: [
        {text: 'Kod resortowy', sortable: false, align: 'left', value: 'kod_resortowy'},
        {text: 'Nazwa', sortable: false, align: 'left', value: 'nazwa'},
        {text: 'Aktywna', sortable: false, align: 'left', value: 'is_active'},
        {text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      settingsService.GetOrganizationalUnits(this.settings_id).then((result)=> {
        this.items = result.data.result
      }).catch(() => {
        this.showError('Błąd pobierania komórek organizacyjnych')
      })
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      })
    },
    editOU(editObj)
    {
      this.editedObject = editObj
      this.showAddEdit = true
    },
    addNew()
    {
      this.editedObject = { id: 0, is_active: true}
      this.showAddEdit = true
    },
    editedDone(val)
    {
      this.showAddEdit = false
      var itm = this.items.find(x=>x.id == val.id)
      if(itm == null)
        this.items.push(val)
      else
      {
        itm.nazwa = val.nazwa
        itm.kod_resortowy = val.kod_resortowy
        itm.is_active = val.is_active
      }
    }
  }
}
</script>

<style scoped>

</style>